import { Locked as LockedIcon } from '@carbon/icons-react';
import { useTheme } from '@repo/theme';
import { FunctionalModal } from 'component/modal/functional-modal';
import { t } from 'util/stdtypes';

export function CloseSpaceModal({ onClose, onConfirm }: { onClose: () => void; onConfirm: () => void }) {
    const { colors } = useTheme();
    return (
        <FunctionalModal
            headingLabel={t('question.actions.close_modal_heading', 'Close this space?')}
            onClose={onClose}
            primaryButton={{
                label: t('question.actions.close_confirm_button', 'Close'),
                icon: <LockedIcon color={colors.colorTextWarning} />,
                type: 'delete',
                onPress: onConfirm,
            }}
            secondaryButton={{
                label: t('modal.cancel_button', 'Cancel'),
                onPress: onClose,
            }}
            subheadingLabel={t(
                'question.actions.close_modal_description',
                'When closed, a space becomes "read only." Most actions are disabled and users cannot post, reply, or react. Users can still report comments. You can reopen the conversation at any time.',
            )}
        />
    );
}
